// © Microsoft Corporation. All rights reserved.
const defaultIds = {
    fbClientId: "223505105588011",
    googleClientId: "967108317934-brcub79f1q5gt8mniu3e912rtrdtmfor.apps.googleusercontent.com"
};

async function facebookLogin(fbClientId?: string): Promise<string> {
    fbClientId = fbClientId || defaultIds.fbClientId;
    return new Promise((resolve, reject) => {
        const callback = function() {
            if (window.FB) {
                window.FB.login((response) => {
                    if (response && response.authResponse) {
                        window.FB.api("/me", {fields: "email" }, (response) => {
                            if (response && response.email) {
                                return resolve(response.email);
                            }
                            return reject();
                        }
                        );
                    } else {
                        // User cancelled login or did not fully authorize.
                        return reject();
                    }
                }, {scope: "email"});
                return;
            }
        };

        if (window.FB) {
            window.FB.init({
                appId: fbClientId
            });
            callback();
            return;
        }
        window.fbAsyncInit = function() {
            window.FB.init({
                appId: fbClientId,
                cookie: true, // This is important, it's not enabled by default
                version: "v7.0"
            });
            callback();
        };

        (function(d, s, id) {
            const fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            const js = <HTMLScriptElement>d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, "script", "facebook-jssdk"));
    });
}

async function googleLogin(googleClientId?: string): Promise<string> {
    googleClientId = googleClientId || defaultIds.googleClientId;
    return new Promise((resolve, reject) => {
        const loginAndGetPassword = function() {
            window.auth2.signIn().then(() => {
                const email = getEmailFromActiveSession();
                if (email) {
                    return resolve(email);
                }
                // Email consent is not given
                reject();
            }).catch((e) => {
                // Login failed
                reject(e);
            });
        };

        const getEmailFromActiveSession = function() {
            try {
                return window.auth2.currentUser.get().getBasicProfile().getEmail();
            } catch (e) {
                return null;
            }
        };

        if (window.auth2) {
            const email = getEmailFromActiveSession();
            if (email) {
                return resolve(email);
            }
            loginAndGetPassword();
            return;
        }

        window.googleInit = function() {
            window.gapi.load("auth2", function() {
                window.auth2 = window.gapi.auth2.init({
                    client_id: googleClientId,
                    scope: "email"
                });
                loginAndGetPassword();
            });
        };

        (function(d, s, id) {
            const fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            const js = <HTMLScriptElement> d.createElement(s); js.id = id;
            js.src = "https://apis.google.com/js/platform.js?onload=googleInit";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, "script", "google-jssdk"));
    });
}

function msaLogin(email?: string, market?: string, replyUrl?: string, isSignup?: boolean): Promise<void> {
    market = market || "en-us";
    replyUrl = replyUrl || `https://www.msn.com/${market}/settings`;
    const redirectLink = `https://www.msn.com/${market}/homepage/Secure/Passport?ru=${encodeURIComponent(replyUrl)}?pfr=1`;
    const baseUrl = isSignup ? "http://signup.live.com/signup.aspx" : "https://login.live.com/login.srf";
    const url = `${baseUrl}?${email ? `username=${encodeURIComponent(email)}` : ""}&wa=wsignin1.0&wp=LBI&wreply=${encodeURIComponent(redirectLink)}`;

    window.msaLoginWindow = window.open(url, "_blank", "width=400,height=450");
    return new Promise((resolve, reject) => {
        window.listenMSALoginWindow = () => {
            if (!window.msaLoginWindow) {
                // Login window is not available anymore
                return reject();
            }
            try {
                if (window.msaLoginWindow &&
                    window.msaLoginWindow.location.href &&
                    window.msaLoginWindow.location.href.indexOf(replyUrl) == 0 &&
                    window.msaLoginWindow.document.body) {
                    // Login sucessfully completed.
                    window.msaLoginWindow.close();
                    return resolve();
                }
            } catch (e) {
                // Login in progress keep retrying
            }
            setTimeout(() => { window.listenMSALoginWindow(); }, 500);
        };
        window.listenMSALoginWindow();
    });
}

export { facebookLogin, googleLogin, msaLogin };